<div>

  <file-upload [control]="coreImageUploadControl" [multiple]="multiple" accept="image/*">
    <ng-template let-isFileDragDropAvailable="isFileDragDropAvailable" #placeholder>
      <file-upload-drop-zone>
        <b>{{ 'core_image_upload.drag_and_drop' | translate }}</b><br>
        {{ 'core_image_upload.or_click_here' | translate }}
      </file-upload-drop-zone>
    </ng-template>

    <ng-template let-i="index" let-file="file" let-control="control" #item>
      <file-upload-list-item [index]="i" [file]="file" [control]="control">{{ 'core_image_upload.remove' | translate
        }}</file-upload-list-item>
    </ng-template>
  </file-upload>
  <p class="text-danger font-italic m-2">
    {{ 'core_image_upload.image_upload_limit' | translate }}<br />
    {{ 'core_image_upload.image_size_limit' | translate }} {{ maxImageSize }}
  </p>
  <div *ngIf="showSaveHint && coreImageUploadControl.value.length" class="alert alert-info py-2 px-3 m-2 mb-0">
    <i class="la la-info-circle mr-1"></i>
    {{ 'core_image_upload.click_save_to_upload' | translate }}
  </div>
</div>
